"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthToken = exports.getAuthHeaders = void 0;
/**
 * Build Authorization header from localStorage. Use in API layers so only the token key differs per app.
 */
function getAuthHeaders(tokenKey) {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem(tokenKey) : null;
    const headers = {
        'Content-Type': 'application/json',
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
}
exports.getAuthHeaders = getAuthHeaders;
function getAuthToken(tokenKey) {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(tokenKey) : null;
}
exports.getAuthToken = getAuthToken;
